<app-dialog-header headerText="{{headerText}}" (onCloseClick)="onCancelClick()"></app-dialog-header>
<form [formGroup]="dialogForm">
	<div mat-dialog-content style="max-width: 500px;">
		<span>{{dialogText}}</span>
		<mat-form-field>
			<mat-label>{{dialogPrompt}}</mat-label>
			<textarea matInput formControlName="comment" maxlength="201"></textarea>
			<mat-hint align="end">{{ getCommentLength() }}/{{maxLength}}</mat-hint>
		</mat-form-field>
		<mat-error *ngIf="dialogForm.get('comment')!.hasError('required')">{{dialogPrompt}} is required</mat-error>
		<mat-error *ngIf="dialogForm.get('comment')!.hasError('maxlength')">{{dialogPrompt}} max Length {{maxLength}} Chars</mat-error>
	</div>
	<div mat-dialog-actions>
		<button mat-button [mat-dialog-close]="dialogForm.value"
			[disabled]="dialogForm.invalid">Ok</button>
		<button mat-button (click)="onCancelClick()" cdkFocusInitial>Cancel</button>
	</div>
</form>
